import { ref, computed, getCurrentInstance } from 'vue';

/**
 * K线 Tab 逻辑 Hook
 * 用于管理 K线图表的时间切换 Tab（日/周/月）
 */
export function useKLineTabs() {
	const { proxy } = getCurrentInstance();

	// K线时间值（默认日线）
	const kLineActValue = ref(1);

	// K线 Tab 列表
	const kLineTabList = computed(() => [
		{
			label: `${proxy.$t('enterprise.day')}`,
			value: 1
		},
		{
			label: `${proxy.$t('enterprise.week')}`,
			value: 2
		},
		{
			label: `${proxy.$t('enterprise.month')}`,
			value: 3
		}
	]);

	// 切换 Tab
	const changeTab = val => {
		kLineActValue.value = val;
	};

	return {
		kLineActValue,
		kLineTabList,
		changeTab
	};
}

